import { AutoApplyStatus } from 'builder/modules/jobTracking'
import { i18n } from 'builder/utils/i18n'
import { selectors as jobSearchSelectors } from 'builder/modules/jobSearch'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import {
  AutoApplyLabel,
  ApplyStatusIcon,
  AutoApplyLabelContent,
  AutoApplyTooltipContent,
  AutoApplyTooltip,
} from './styles'
import RedDocument from './assets/document.svg'
import CircleCheckSvg from './assets/circleCheck.svg'
import CircleClockSvg from './assets/circleClock.svg'
import CircleErrorSvg from './assets/circleError.svg'
import DisabledCircleClockSvg from './assets/disabledCircleClock.svg'
import MailSvg from './assets/mailIcon.svg'

export const AutoApplyStatusLabel = ({
  autoApplyStatus,
  ...rest
}: {
  autoApplyStatus: AutoApplyStatus
  setAllowOverflow?: ((val: boolean) => void) | undefined
}) => {
  const autoApplyBubbles = useTypedSelector(jobSearchSelectors.autoApplyBubbles)

  const getIconByStatus = () => {
    if (autoApplyStatus === 'processing') return CircleClockSvg
    if (autoApplyStatus === 'auto_applied') return CircleCheckSvg
    if (autoApplyStatus === 'error') return CircleErrorSvg
    if (autoApplyStatus === 'information_required') return MailSvg
    if (autoApplyStatus === 'no_application_made') return DisabledCircleClockSvg
    if (autoApplyStatus === 'auto_tailoring_failed') return RedDocument

    return CircleClockSvg
  }

  if (autoApplyBubbles.running) {
    return null
  }
  return (
    <AutoApplyLabel autoApplyStatus={autoApplyStatus} {...rest}>
      <AutoApplyTooltip
        placement="bottom"
        content={
          <AutoApplyTooltipContent>
            {i18n.t(`builder.job_tracking.auto_apply.tooltip.${autoApplyStatus}`)}
          </AutoApplyTooltipContent>
        }
      >
        <AutoApplyLabelContent>
          <ApplyStatusIcon src={getIconByStatus()} />
          {i18n.t(`builder.job_tracking.auto_apply.labels.${autoApplyStatus}`)}
        </AutoApplyLabelContent>
      </AutoApplyTooltip>
    </AutoApplyLabel>
  )
}
